// ════════════════════════════════════════════════════════════════════════════
//  Udisys Gestor Web — features/whatsappCloud/service.ts
// ════════════════════════════════════════════════════════════════════════════

import { apiClient } from '@/lib/apiClient';
import type {
  WhatsAppCloudConfig,
  SalvarWhatsAppCloudRequest,
  SeedTemplatesResult,
  WhatsAppEmbeddedConfig,
  OnboardWhatsAppRequest,
} from './types';

export const whatsappCloudService = {
  getConfig: () =>
    apiClient.get<WhatsAppCloudConfig>('/api/gestao/whatsapp').then(r => r.data),

  salvar: (req: SalvarWhatsAppCloudRequest) =>
    apiClient.put<WhatsAppCloudConfig>('/api/gestao/whatsapp', req).then(r => r.data),

  teste: (numero: string, texto?: string) =>
    apiClient.post<{ ok: boolean; idExterno?: string }>('/api/gestao/whatsapp/teste', { numero, texto })
      .then(r => r.data),

  // Cria ~11 templates em sequência na Graph; o timeout global de 15s do apiClient estoura
  // antes de terminar (e o abort cancela no servidor, deixando o seed pela metade). 60s dá folga.
  seedTemplates: () =>
    apiClient.post<SeedTemplatesResult>('/api/gestao/whatsapp/templates/seed', undefined, { timeout: 60_000 })
      .then(r => r.data),

  getEmbeddedConfig: () =>
    apiClient.get<WhatsAppEmbeddedConfig>('/api/gestao/whatsapp/embedded-config').then(r => r.data),

  // Troca code→token + subscribed_apps + sync de coexistência na Graph: pode passar de 15s.
  onboarding: (req: OnboardWhatsAppRequest) =>
    apiClient.post<WhatsAppCloudConfig>('/api/gestao/whatsapp/onboarding', req, { timeout: 60_000 })
      .then(r => r.data),
};
